(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["donreloj-stock-alert"] && !Shopify.designMode) return;
  try {
    (async () => {
    const { StandardEvents } = await import('@shopify/events');
    if (customElements.get('donreloj-stock-alert')) return;

    class DonRelojStockAlert extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.sequence = 0;
        this.scope = this.closest('.shopify-section, dialog');
        this.scope?.addEventListener(StandardEvents.productSelect, this.onProductSelect, {
          signal: this.controller.signal,
        });
      }

      disconnectedCallback() {
        this.sequence += 1;
        this.controller?.abort();
      }

      onProductSelect = (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        if (event.target.closest('.shopify-section, dialog') !== this.scope || !event.promise) return;
        const sequence = ++this.sequence;
        this.setAttribute('aria-busy', 'true');
        const title = this.querySelector('.dr-stock__title');
        if (title) title.textContent = this.dataset.loading;
        this.querySelector('.dr-stock')?.classList.remove('dr-stock--low');
        for (const item of this.querySelectorAll('.dr-stock__eyebrow, .dr-stock__variant, .dr-stock__hint')) {
          item.style.visibility = 'hidden';
        }

        event.promise.then(({ detail }) => {
          if (!this.isConnected || sequence !== this.sequence) return;
          const fresh = Array.from(detail?.html?.querySelectorAll('donreloj-stock-alert') || [])
            .find((element) => element.dataset.blockId === this.dataset.blockId);
          if (!fresh || !detail?.resource?.id || fresh.dataset.variantId !== String(detail.resource.id)) {
            this.hidden = true;
          } else {
            this.replaceChildren(...Array.from(fresh.childNodes, (node) => node.cloneNode(true)));
            this.dataset.productId = fresh.dataset.productId;
            this.dataset.variantId = fresh.dataset.variantId;
            this.hidden = fresh.hidden;
          }
          this.removeAttribute('aria-busy');
        }).catch(() => {
          if (!this.isConnected || sequence !== this.sequence) return;
          this.hidden = true;
          this.removeAttribute('aria-busy');
        });
      };
    }

    customElements.define('donreloj-stock-alert', DonRelojStockAlert);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dr-product-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dr-product-actions')) customElements.define('dr-product-actions', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const labels = JSON.parse(this.querySelector('[data-labels]').textContent);
    this.querySelector('[data-share]').addEventListener('click', async () => {
      const url = new URL(this.dataset.url, location.origin).href;
      try { if (navigator.share) await navigator.share({ title: this.dataset.title, url }); else { await navigator.clipboard.writeText(url); this.querySelector('[data-status]').textContent = labels.copied; } }
      catch (error) { if (error.name !== 'AbortError') this.querySelector('[data-status]').textContent = url; }
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
});
  } catch(e) { console.error(e); }
})();

})();
